var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "nk-sidebar nk-sidebar-fixed nk-sidebar-resizable sip-school-sidebar",
      class: { "is-user-collapsed": _vm.isUserCollapsed },
      style: _vm.sidebarStyle,
      attrs: { id: "MainSideBarRightMenu", "data-content": "sidebarMenu" },
    },
    [
      _c("div", { staticClass: "nk-sidebar-element nk-sidebar-head" }, [
        _c(
          "div",
          {
            staticClass:
              "nk-sidebar-brand d-flex align-items-center justify-content-between w-100",
          },
          [
            _c(
              "a",
              {
                staticClass: "sip-school-brand",
                attrs: { href: "/home", "aria-label": "Home" },
              },
              [
                _c(
                  "span",
                  { staticClass: "sip-school-brand__mark" },
                  [
                    !_vm.logoLoadError && _vm.getLogoUrl
                      ? _c("img", {
                          staticClass: "sip-school-brand__logo",
                          class: {
                            "is-fallback": _vm.isDarkMode && !_vm.hasDarkLogo,
                          },
                          attrs: { src: _vm.getLogoUrl, alt: "Sipinor" },
                          on: {
                            error: function ($event) {
                              _vm.logoLoadError = true
                            },
                          },
                        })
                      : _c("admin-icon", {
                          attrs: {
                            name: "school",
                            size: _vm.isUserCollapsed ? 30 : 38,
                          },
                        }),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nk-menu-trigger me-n2" }, [
          _c(
            "a",
            {
              staticClass: "nk-nav-toggle nk-quick-nav-icon d-xl-none",
              attrs: {
                "data-target": "sidebarMenu",
                id: "HideRightSideBarMenu",
                "aria-label": "Close menu",
              },
            },
            [_c("admin-icon", { attrs: { name: "close", size: 18 } })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "nk-sidebar-element" }, [
        _c("div", { staticClass: "nk-sidebar-content" }, [
          _c("div", { staticClass: "nk-sidebar-menu" }, [_c("main-menu")], 1),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nk-sidebar-element sip-side-profile-wrap" },
        [
          _c("sidebar-profile", {
            attrs: { "is-collapsed": _vm.isUserCollapsed },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "nk-sidebar-resize-handle",
        attrs: { title: "Drag to resize sidebar" },
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
            return _vm.startResize.apply(null, arguments)
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }